import { User } from './User';

export interface CurrentUser {
  avatar_picture: string;
  email: string;
  name: string;
  first_name?: string;
  organization?: string;
  department?: string;
  occupation?: string;
  location?: {
    zipcode?: string;
    city?: string;
    country?: string;
  };
  visibility?: {
    email?: boolean;
    organization?: boolean;
    department?: boolean;
    occupation?: boolean;
    location?: {
      zipcode?: boolean;
      city?: boolean;
      country?: boolean;
    };
  };
  emailSettings?: {
    notifEmails: {
      userInvitedAsCollaborator: boolean;
      userAddedAsCollaborator: boolean;
      someoneAddedAsCollaborator: boolean;
      someoneCommented: boolean;
      mentionedInComment: boolean;
      commentReplied: { type: boolean; default: true };
      someoneRequestedCollaboration: boolean;
      directMessage: boolean;
    };
  };
  notifications: any[];
  profile_picture: string;
  provider: string;
  registered: boolean;
  role: string;
  __v: number;
  _id: string;
  default_session_id?: string;
}

export function publicView(current: CurrentUser) {
  const user: User = {
    _id: current._id,
    first_name: current.first_name,
    name: current.name,
    organization: current.organization,
    profile_picture: current.profile_picture,
  };

  if (!current.visibility || current.visibility.email === true) {
    user.email = current.email;
  }

  if (!current.visibility || current.visibility.department !== false) {
    user.department = current.department;
  }

  if (!current.visibility || current.visibility.occupation !== false) {
    user.occupation = current.occupation;
  }

  if (current.location) {
    user.location = {};

    if (
      !current.visibility ||
      !current.visibility.location ||
      current.visibility.location.zipcode !== false
    ) {
      user.location.zipcode = current.location.zipcode;
    }

    if (
      !current.visibility ||
      !current.visibility.location ||
      current.visibility.location.city !== false
    ) {
      user.location.city = current.location.city;
    }

    if (
      !current.visibility ||
      !current.visibility.location ||
      current.visibility.location.country !== false
    ) {
      user.location.country = current.location.country;
    }
  }

  return user;
}
